import {Flex, Box} from '@chakra-ui/react';
import {ResponsiveImageType} from 'react-datocms';
import {Carousel} from '../index/carousel/carousel';

interface ImageCarouselProps {
  background?: string;
  images: [
    {
      responsiveImage: ResponsiveImageType;
    },
  ];
}

export const ImageCarousel: React.FC<ImageCarouselProps> = ({
  images,
  background,
}) => {
  return (
    <Flex
      bg={background}
      justifyContent="center"
      alignItems="center"
      width="100%"
      px="40px"
      py={6}
    >
      {images.length > 0 && (
        <Box maxW={{base: '100%', md: '765px', lg: '975px'}} width="100%">
          <Carousel
            images={images.map((image) =>
              image.responsiveImage
                ? (`${image.responsiveImage.src}?auto=format&w=800&h=500&fit=crop` as string)
                : '',
            )}
          />
        </Box>
      )}
    </Flex>
  );
};
